
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const NOINDEX_PATHS = [
  /^\/campaigns\/rust-course-launch-/,
  /^\/campaigns\/rust-course-launch-thank-you$/,
  /^\/campaigns\/.*/  // Block indexing for all campaign pages
];

export const RobotsMiddleware = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Check if the current path should be noindexed
    const shouldNoIndex = NOINDEX_PATHS.some(pattern => pattern.test(pathname));
    
    if (shouldNoIndex) {
      // Add/update the robots meta tag
      let metaRobots = document.querySelector('meta[name="robots"]');
      if (!metaRobots) {
        metaRobots = document.createElement('meta');
        metaRobots.setAttribute('name', 'robots');
        document.head.appendChild(metaRobots);
      }
      metaRobots.setAttribute('content', 'noindex, nofollow');
      
      // Add the X-Robots-Tag HTTP header equivalent as a meta tag
      let metaXRobots = document.querySelector('meta[http-equiv="X-Robots-Tag"]');
      if (!metaXRobots) {
        metaXRobots = document.createElement('meta');
        metaXRobots.setAttribute('http-equiv', 'X-Robots-Tag');
        document.head.appendChild(metaXRobots);
      }
      metaXRobots.setAttribute('content', 'noindex, nofollow');
    } else {
      // Remove noindex tags if they exist and shouldn't be there
      const metaRobots = document.querySelector('meta[name="robots"][content="noindex, nofollow"]');
      if (metaRobots) {
        metaRobots.remove();
      }
      
      const metaXRobots = document.querySelector('meta[http-equiv="X-Robots-Tag"]');
      if (metaXRobots) {
        metaXRobots.remove();
      }
    }
  }, [pathname]);

  return null;
};

export default RobotsMiddleware;
